import type { ResolvedTenant } from '../types';

function link(attrs: Record<string, string>): HTMLLinkElement {
  const el = document.createElement('link');
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
  return el;
}

/** Runs before React mounts: title, favicons, tenant stylesheet. No flash of Alison branding. */
export function applyHead(tenant: ResolvedTenant): void {
  document.title = tenant.providerName;
  if (tenant.isAlison) return; // index.html already carries the Alison favicon
  for (const el of document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]')) {
    el.remove();
  }
  const type = tenant.icon.endsWith('.svg') ? 'image/svg+xml' : 'image/png';
  document.head.append(
    link({ rel: 'icon', href: tenant.icon, type, sizes: '32x32' }),
    link({ rel: 'icon', href: tenant.icon, type, sizes: '192x192' }),
    link({ rel: 'apple-touch-icon', href: tenant.icon, sizes: '180x180' }),
  );
  if (tenant.stylesheet) document.head.append(link({ rel: 'stylesheet', href: tenant.stylesheet }));
}
